export const filterConstants = {
  FILTER_LIST: "FILTER_LIST",
  FILTER_TOTAL: "FILTER_TOTAL",
  FILTER_LOADING_LIST: "FILTER_LOADING_LIST",
  FILTER_RESET: "FILTER_RESET"
};
